<template>
  <svg class="sparkline" :width="width" :height="height">
    <path class="sparkline--line" :d="shape" fill="none" :stroke-width="stroke"></path>
    <path
      class="sparkline--fill"
      :d="[shape, fillEndPath].join(' ')"
      stroke="none"
    ></path>
  </svg>
</template>

<script setup lang="ts">
  // logic taken and adapted from https://dev.to/mailmeteor/how-to-add-a-sparkline-for-your-vue-js-app-1c4h
  
  import { computed, PropType } from "vue";
  
  const props = defineProps({
    data: { type: Array as PropType<Array<number>>, required: true },
    bottomLine: { type: Number, required: true },
    highLine: { type: Number, required: true },
    stroke: { type: Number, required: false, default: 3 },
    width: { type: Number, required: false, default: 180 },
    height: { type: Number, required: false, default: 40 },
  });
  
  const shape = computed(() => {
    const stroke = props.stroke;
    const width = props.width;
    const height = props.height - stroke * 2;
    const data = props.data || [];
    let highestPoint = Math.max.apply(null, data) + 1;
    if (props.highLine && props.highLine + 3 > highestPoint) {
      highestPoint = props.highLine + 3;
    }
    const coordinates = [] as any[];
    const totalPoints = props.data.length - 1;
    data.forEach((item, n) => {
      const x = (n / totalPoints) * width + stroke;
      const y = height - (item / highestPoint) * height + stroke;
      coordinates.push({ x, y });
    });
    if (!coordinates[0]) {
      return (
        "M 0 " +
        props.stroke +
        " L 0 " +
        props.stroke +
        " L " +
        props.width +
        " " +
        props.stroke
      );
    }
    const path = [] as any[];
    coordinates.forEach((point: any) =>
      path.push(["L", point.x, point.y].join(" "))
    );
    return ["M" + coordinates[0].x, coordinates[0].y, ...path].join(" ");
  });
  
  const fillEndPath = computed(() => {
    return `V ${props.height} L 4 ${props.height} Z`;
  });
</script>

<style scoped>
  .sparkline {
    stroke: rgb(60, 97, 140);
    fill: rgba(60, 97, 140, 0.1);
    transition: all 1s ease-in-out;
  }
  svg path {
    box-sizing: border-box;
  }
</style>